/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=fd01fc0e&scoped=true"
import script from "./PageFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./PageFooter.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PageFooter.vue?vue&type=style&index=0&id=fd01fc0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_387906ce4ecacbd1e1278429d52c3372/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd01fc0e",
  null
  
)

export default component.exports